import { render, staticRenderFns } from "./SettingsBillingPlansContact.vue?vue&type=template&id=757b2062&"
import script from "./SettingsBillingPlansContact.vue?vue&type=script&lang=js&"
export * from "./SettingsBillingPlansContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports